<template>
<span :class="spinClass">
    <div
        :class="maskClass"
        ref="content"
        v-if="showLoading"
        :style="{ zIndex }">
        <span :class="wrapperClassName">
            <svg
                v-if="!indicator"
                :class="bem('icon', sizeClass)"
                :style="sizeStyle"
                x="0px"
                y="0px"
                width="1em"
                height="1em"
                viewBox="0 0 50 50">
                <g>
                    <circle
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        opacity=".2"
                        stroke="#000"
                        stroke-width="4px"/>
                    <circle
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        stroke="#2254F4"
                        stroke-width="4px"
                        stroke-dasharray="70"/>
                </g>
            </svg>
            <Icon :class="bem('icon', sizeClass)" :name="indicator" v-else/>
            <span v-if="tip">{{ tip }}</span>
        </span>
    </div>
    <slot/>
</span>

</template>
<script>
import {bemMixin} from "../utils";
import Icon from "../icon";
export default {
  name: "g-spin",
  components: {Icon},
  mixins: [bemMixin],
  props: {
    size: {
      type: [String, Number],
      default: "normal"
    },
    loading: {
      type: Boolean,
      default: true
    },
    tip: {
      type: String,
      default: ""
    },
    delay: {
      type: Number,
      default: 0
    },
    wrapperClassName: {
      type: String,
      default: ""
    },
    indicator: {
      type: String,
      default: ""
    },
    zIndex: {
      type: [String, Number],
      default: 9
    }
  },
  data() {
    return {
      timer: null,
      showLoading: false,
      innerVisible: false,
      appendToBody: false
    };
  },
  computed: {
    sizeClass() {
      let classObj = {};
      classObj[this.size] = true;
      return classObj;
    },
    sizeStyle() {
      if (!isNaN(+this.size)) {
        return {
          fontSize: this.size + "px"
        };
      }
      return null;
    },
    maskClass() {
      const isSlot = !!this.$slots.default;
      if (this.appendToBody) {
        return this.bem("mask", "append");
      }
      return this.bem(isSlot ? "mask" : "no-mask");
    },
    spinClass() {
      const isSlot = !!this.$slots.default;
      return isSlot ? this.bem("", "content") : this.bem();
    }
  },
  watch: {
    loading: {
      handler(val) {
        clearTimeout(this.timer);
        if (this.delay && !val) {
          this.timer = setTimeout(() => {
            this.showLoading = val;
          }, this.delay);
        } else {
          this.showLoading = val;
        }
      },
      immediate: true
    },
    appendToBody(val) {
      if (val) {
        document.body.appendChild(this.$refs.content);
      } else {
        document.body.removeChild(this.$refs.content);
        this.$destroy();
      }
    }
  }
};

</script>
<style>
.g-spin {
  display: inline-block;
  position: relative;
}
.g-spin--content {
  width: 100%;
}
.g-spin__mask {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: hsla(0, 0%, 100%, 0.7);
}
.g-spin__mask--append {
  display: inline-block;
  position: fixed;
}
.g-spin__mask--append > span {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.g-spin__no-mask {
  display: inline-block;
}
.g-spin__mask > span,
.g-spin__no-mask > span {
  display: flex;
  align-items: center;
  justify-content: center;
}
.g-spin__icon {
  display: inline-block;
  vertical-align: bottom;
  margin-right: 8px;
  animation: loading-rotate 0.8s linear infinite;
}
.g-spin__icon--small {
  font-size: 16px;
}
.g-spin__icon--normal {
  font-size: 24px;
}
.g-spin__icon--large {
  font-size: 32px;
}
@keyframes loading-rotate {
  to {
    transform: rotate(1turn);
  }
}

</style>
